// Parse the URL parameter
var dynamicContent = window.mcsUtils.getParameterByName('dc');

$(document).ready(function () {
  $(".show-mac").click(function () {
    $("#windows-options").hide();
    $("#mac-options").show();
    $(".show-mac").addClass("selected");
    $(".show-windows").removeClass("selected");
  });
  $(".show-windows").click(function () {
    $("#windows-options").show();
    $("#mac-options").hide();
    $(".show-windows").addClass("selected");
    $(".show-mac").removeClass("selected");
  });
  // Check if the URL parameter is apple
  if (dynamicContent == 'mac') {
    $("#windows-options").hide();
    $("#mac-options").show();
    $(".show-mac").addClass("selected");
    $(".show-windows").removeClass("selected");
  }
  $('a[href*=\\#]:not([href=\\#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top-250
        }, 1000);
        return false;
      }
    }
  });
});